<template>
  <NuxtLayout
    v-if="data"
    name="generic"
    :header="data.header"
    :footer="data.footer"
  >
    <SectionBuilder
      v-if="data.content"
      v-bind="data.content"
      id="base-template"
      :class="{
        'base-wrapper text-www-color-neutral-medium-dark': true,
      }"
    />

    <CTABanner
      v-if="data.CTABanner?.reference"
      :data="data.CTABanner.reference"
    />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import SectionBuilder from '~/components/Atmos/SectionBuilder/SectionBuilder.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';
import { queryBase } from '~/queries/pages/PageBase.query';
import type { QueryBaseResult } from '~/sanity/types';
import { extractAbstractFromSectionBuilder } from '~/utils/extractBreakoutSummary';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryBaseResult>(queryBase, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.baseCardImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'CreativeWork',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.description,
      abstract: extractAbstractFromSectionBuilder(data.value?.content),
      enabled: true,
    },
  ],
});
</script>

<style lang="scss">
.base-wrapper {
  .signup-headline-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 25px;
    margin-left: 0 !important;
    padding-left: 0 !important;

    @media (min-width: 768px) {
      flex-direction: row;
      gap: 55px;
    }

    li {
      color: var(--www-color-primary-lighter);
      font-family: Rajdhani;
      font-size: 18px;
      font-weight: 700;
      line-height: normal;
      text-align: center;
      list-style-type: none !important;
      position: relative;
      &:last-child {
        &::after {
          display: none;
        }
      }
      @media (min-width: 768px) {
        &::after {
          content: '';
          position: absolute;
          display: block;
          background: #dedede;
          border-radius: 50%;
          height: 10px;
          width: 10px;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
